import { MenuEntryWithTranslatedLabel } from '@shared-util-lib/models/menu-entry.model'

export const sortEntries = (entries: MenuEntryWithTranslatedLabel[]) =>
    entries.sort((first, second) =>
        first.translatedLabel.localeCompare(second.translatedLabel)
    )
